import React from "react";
import Button from "@/common/elements/Button";
import Checkbox from "@/common/elements/InputElements/CheckBox";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import TextField from "@/common/elements/InputElements/TextField";
import { StyledGridCol, StyledGridRow, StyledSectionHeading } from "@/common/styles";
import useDialog from "@/hooks/useDialog";
import { getOptionsFromRefList } from "@/util/common_function";
import { useSelector } from "react-redux";
import { Form } from "antd";

const JailIncidenSanctionInformation = ({ data, disabled = false }) => {
  const { showDialog } = useDialog();
  const refList = useSelector((state) => state?.refListReducer?.refLists);

  const sanctionOptions = getOptionsFromRefList("JailIncidentsSanctions", false, false, true);

  const initialValues = sanctionOptions.reduce((acc, option) => {
    acc[`sanction_${option.value}`] =
      data?.jailIncidentsInvolvedInmateSanctions?.some(
        (s) => s.jailIncidentsSanctionsId === option.value
      ) || false;
    return acc;
  }, {});
  initialValues.comments = data?.sanctionComments || "";

  const onHandleViewComment = () => {
    const comment = data?.sanctionComments || "No comment available";
    showDialog("info", {
      content: comment,
      confirmButtonText: "Ok",
    });
  };

  return (
    <>
      <StyledSectionHeading marginTop="20px">
        <span>Sanction Information</span>
      </StyledSectionHeading>

      <Form name="jailIncidenSanctionInformation" initialValues={initialValues}>
        <StyledGridRow gutter={16}>
          {sanctionOptions.map((option, index) =>
            index !== 0 ? (
              <StyledGridCol lg={6} key={option.value}>
                <FormItem
                  label={option.label}
                  layout="horizontal"
                  labelPostion="label-right"
                  name={`sanction_${option.value}`}
                  valuePropName="checked"
                >
                  <Checkbox disabled={disabled} />
                </FormItem>
              </StyledGridCol>
            ) : null
          )}
        </StyledGridRow>

        <StyledGridRow gutter={16}>
          <StyledGridCol lg={24} marginTop="12px">
            <FormItem label="Comments" name="comments">
              <TextField inputType="textarea" rows="3" disabled={disabled} />
            </FormItem>
            <Button
              type="secondary"
              color="secondary"
              onClick={onHandleViewComment}
            >
              View Comments
            </Button>
          </StyledGridCol>
        </StyledGridRow>
      </Form>
    </>
  );
};

export default JailIncidenSanctionInformation;
